var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29006 6.70782C8.90006 7.09782 8.90006 7.72782 9.29006 8.11782L13.1701 11.9978L9.29006 15.8778C8.90006 16.2678 8.90006 16.8978 9.29006 17.2878C9.68006 17.6778 10.3101 17.6778 10.7001 17.2878L15.2901 12.6978C15.6801 12.3078 15.6801 11.6778 15.2901 11.2878L10.7001 6.69782C10.3201 6.31782 9.68006 6.31782 9.29006 6.70782Z",
    fill: "#EB008D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7188 6.70782C15.3288 7.09782 15.3288 7.72782 15.7188 8.11782L19.5988 11.9978L15.7188 15.8778C15.3288 16.2678 15.3288 16.8978 15.7188 17.2878C16.1088 17.6778 16.7388 17.6778 17.1288 17.2878L21.7188 12.6978C22.1088 12.3078 22.1088 11.6778 21.7188 11.2878L17.1288 6.69782C16.7488 6.31782 16.1088 6.31782 15.7188 6.70782Z",
    fill: "#EB008D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowRight);
export default __webpack_public_path__ + "static/media/DoubleArrowRight.677fff6add45e481edd6f59ba267470a.svg";
export { ForwardRef as ReactComponent };